module.exports = __webpack_public_path__ + "static/media/apollo.393e9a67.svg";